import { EmptyState, Flex, Pane, spaces, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import { Store } from '@/types/storefront';

type ItemListEmptyStateProps = {
  store: Store;
};

export const ItemListEmptyState = ({ store }: ItemListEmptyStateProps) => {
  const { t } = useTranslation('storefront');
  if (store === Store.Catalog) {
    return (
      <Pane
        elevated
        width="100%"
        justifyContent="center"
        padding={spaces.space_2xs}>
        <EmptyState
          title={t('itemList.emptyState.catalog.title')}
          subTitle={t('itemList.emptyState.catalog.subtitle')}
          icon="laptop"
        />
      </Pane>
    );
  } else if (store === Store.Asset) {
    return (
      <Pane
        elevated
        width="100%"
        justifyContent="center"
        padding={spaces.space_2xs}>
        <EmptyState
          title={t('itemList.emptyState.asset.title')}
          subTitle={
            <Flex vertical alignItems="center">
              <Text>{t('itemList.emptyState.asset.subtitle1')}</Text>
              <Text>{t('itemList.emptyState.asset.subtitle2')}</Text>
            </Flex>
          }
          icon="laptop"
        />
      </Pane>
    );
  } else {
    return null;
  }
};
